// extracted by mini-css-extract-plugin
module.exports = {"line-number":"_1OFI4","lineNumber":"_1OFI4"};